"use client";

import { logEvent } from "@/service/logs/log";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";

import { createPath } from "@/service/routing/routing";
import { CourseCard } from "@/components/course/course-card/course-card";

export const Icd10CourseCard = ({
  data,
  code,
}: {
  data: CoursePreviewVM;
  code: string;
}) => {
  const { logView } = useContext(ResourceContext);

  const link = createPath("course.show", {
    slug: data.slug,
    id: data.id,
  });

  return (
    <CourseCard
      course={data}
      onClick={() => {
        logEvent("icd10_internal_link_click", logView, {
          icd_code: code,
          resource_path: link,
          resource_type: "course",
        });
      }}
    />
  );
};
